/**
 * 高精度价格计算工具类 - 解决JS浮点数精度丢失问题
 * 所有方法均保留2位小数（价格标准）
 */
export const PriceCalc = {
  /**
   * 私有方法：放大数字，消除小数（核心解决精度的方法）
   * @param {Number} num - 原始数字
   * @returns {Number} 放大后的整数
   */
  _toInteger(num) {
    num = Number(num);
    if (isNaN(num)) return 0;
    // 统一放大100倍，价格只需要精确到分（2位小数）
    return Math.round(num * 100);
  },

  /**
   * 加法运算
   * @param {Number} a - 加数
   * @param {Number} b - 被加数
   * @returns {Number} 计算结果（Number类型，2位小数）
   */
  add(a, b) {
    return (this._toInteger(a) + this._toInteger(b)) / 100;
  },

  /**
   * 减法运算
   * @param {Number} a - 减数
   * @param {Number} b - 被减数
   * @returns {Number} 计算结果（Number类型，2位小数）
   */
  sub(a, b) {
    return (this._toInteger(a) - this._toInteger(b)) / 100;
  },

  /**
   * 乘法运算
   * @param {Number} a - 乘数
   * @param {Number} b - 被乘数
   * @returns {Number} 计算结果（Number类型，2位小数）
   */
  mul(a, b) {
    a = Number(a) || 0;
    b = Number(b) || 0;
    return Math.round(a * b * 100) / 100;
  },

  /**
   * 除法运算
   * @param {Number} a - 被除数
   * @param {Number} b - 除数
   * @returns {Number} 计算结果（Number类型，2位小数）
   */
  div(a, b) {
    a = Number(a) || 0;
    b = Number(b) || 1;
    if (b === 0) return 0; // 防止除0错误
    return Math.round((a / b) * 100) / 100;
  },

  /**
   * 四舍五入保留2位小数（价格专用）
   * @param {Number} num - 原始数字
   * @returns {Number} 格式化后数字
   */
  round(num) {
    num = Number(num) || 0;
    return Math.round(num * 100) / 100;
  },

  /**
   * 金额格式化（添加千分位 + 保留2位小数）
   * 例：1234.56 → 1,234.56
   * @param {Number} num - 原始金额
   * @returns {String} 格式化后的金额字符串
   */
  format(num) {
    num = this.round(num);
    return num.toLocaleString('zh-CN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
};